import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrMultistateCheckbox from '@components/BrMultistateCheckbox';
import BrDropdownMenu from '@components/BrDropdownMenu';
import './brMultistateCheckboxDropdown.scss';

const AllState = {
  title: 'All',
  condition: () => {
    return true;
  },
};
const NoneState = { title: 'None', condition: () => false };

const PartialState = {
  title: 'Partial',
  condition: (row) => {
    const { isEditable, isLive } = row.Original_Data;
    const isReadOnly = !isEditable || isLive;
    return !isReadOnly;
  },
};

export default class BrMultistateCheckboxDropdown extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    batchSelectOptions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.any.isRequired, // unique key
        title: PropTypes.string.isRequired, // option display text
        condition: PropTypes.func.isRequired, // data row will be passed as param  (row) => {}
      }),
    ),
    onBatchSelect: PropTypes.func.isRequired, // condition function will be passed (condition) => {}
    selectableLength: PropTypes.number.isRequired,
    selectedLength: PropTypes.number.isRequired,
    useDefaultRowConfigValues: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    batchSelectOptions: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line max-len
      options: props.useBulkActions ? [...props.batchSelectOptions] : [AllState, NoneState, ...props.batchSelectOptions],
    }; // may use initial props
  }

  componentDidUpdate(prevProps) {
    // Check if a specific condition is met before updating the state
    if (this.props.batchSelectOptions && this.props.batchSelectOptions !== prevProps.batchSelectOptions) {
      // Update the state based on the condition
      if (this.props.useDefaultRowConfigValues) {
        this.setState({ options: [AllState, NoneState, ...this.props.batchSelectOptions] });
      } else {
        this.setState({ options: [...this.props.batchSelectOptions] });
      }
    }
  }

  handleSelectOption = (item) => {
    this.props.onBatchSelect(item.condition, item.key);
  };

  handleClickCheckbox = (nextState) => {
    const { onBatchSelect } = this.props;
    if (nextState === BrMultistateCheckbox.State.All) {
      onBatchSelect(AllState.condition);
    } else {
      onBatchSelect(NoneState.condition);
    }
  };

  handleClickCheckboxV2 = (nextState) => {
    const { onBatchSelect } = this.props;
    if (nextState === BrMultistateCheckbox.State.All) {
      onBatchSelect(AllState.condition, 'All');
    } else if (nextState === BrMultistateCheckbox.State.Partial) {
      onBatchSelect(PartialState.condition, 'Partial');
    } else {
      onBatchSelect(NoneState.condition, 'None');
    }
  }

  render() {
    const { className, selectableLength, selectedLength, useBulkActions } = this.props;
    const { options } = this.state;
    const checkboxState = selectedLength === 0
      ? BrMultistateCheckbox.State.None
      : selectedLength >= selectableLength
        ? BrMultistateCheckbox.State.All
        : BrMultistateCheckbox.State.Partial;
    const classname = cn('br-multistate-checkbox-dropdown', className);
    const bulkActionsClassname = useBulkActions ? 'bulk-actions' : '';
    return (
      <div className={classname}>
        <BrDropdownMenu
          className="multistate-dropdown dropdown-border"
          title={
            useBulkActions ? (
              <div className={bulkActionsClassname}>
                <BrMultistateCheckbox
                  useBulkActions={useBulkActions}
                  state={checkboxState}
                  onClickCheckbox={this.handleClickCheckboxV2}
                />
                {
                  selectedLength > 0 && (
                    <div className="selected-items">
                      {checkboxState === BrMultistateCheckbox.State.All
                        ? `${selectedLength} selected (all)`
                        : `${selectedLength} selected`}
                    </div>
                  )
                }
              </div>
            ) : (
              <BrMultistateCheckbox
                state={checkboxState}
                useBulkActions={useBulkActions}
                onClickCheckbox={this.handleClickCheckbox}
              />
            )
          }
          items={options}
          useBtnStyle={false}
          onSelect={this.handleSelectOption}
          useNewVariantDownCarrot={useBulkActions}
        />
      </div>
    );
  }
}
